import { TreeNodeInfo } from '@blueprintjs/core';

export type TreeNodeId = TreeNodeInfo['id'];

export const filterEmptyNodes = (node: TreeNodeInfo) =>
  node.childNodes && node.childNodes.length > 0;

export const forEachNode = <T>(
  nodes: Array<TreeNodeInfo<T>> | undefined,
  callback: (
    node: TreeNodeInfo<T>,
    parentNodes: Array<TreeNodeInfo<T>>
  ) => void,
  parentNodes: Array<TreeNodeInfo<T>> = []
) => {
  if (nodes === undefined) {
    return;
  }
  nodes.forEach((node) => {
    callback(node, parentNodes);
    forEachNode(node.childNodes, callback, [...parentNodes, node]);
  });
};

export const findMapNode = <T, R>(
  nodes: Array<TreeNodeInfo<T>> | undefined,
  findMap: (
    node: TreeNodeInfo<T>,
    parentNodes: Array<TreeNodeInfo<T>>
  ) => R | undefined,
  parentNodes: Array<TreeNodeInfo<T>> = []
): R | undefined => {
  if (nodes === undefined) {
    return undefined;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const node of nodes) {
    let value = findMap(node, parentNodes);
    if (value !== undefined) {
      return value;
    }

    value = findMapNode(node.childNodes, findMap, [...parentNodes, node]);
    if (value !== undefined) {
      return value;
    }
  }

  return undefined;
};

export const findNode = <T>(
  nodes: Array<TreeNodeInfo<T>> | undefined,
  find: (node: TreeNodeInfo<T>) => boolean
): TreeNodeInfo<T> | undefined => {
  if (nodes === undefined) {
    return undefined;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const node of nodes) {
    if (find(node)) {
      return node;
    }

    if (node.childNodes) {
      const found = findNode(node.childNodes, find);
      if (found) {
        return found;
      }
    }
  }

  return undefined;
};
